import { createApp } from 'vue'
import App from '@us/app/App.vue'
import initRouter from '@us/app/router'
import i18n from '@shared/localization'
import { initApi } from '@shared/api-client'
import directives from '@shared/directives'
import Tracker from '@shared/Tracker'
import updateInitialPathAndQueryWithTrackingData from '@us/app/helpers/updateInitialPathAndQueryWithTrackingData.js'
import { generateSignupContext } from '@shared/utils'
import { createPinia } from 'pinia'
import { createPersistedState } from 'pinia-plugin-persistedstate'
import useUsStore from '@us/app/stores/useUsStore.js'
import usePersistedConfigStore from '@shared/stores/usePersistedConfigStore.js'
import useCorporateStore from '@shared/stores/useCorporateStore.js'
import useSharedStore from '@shared/stores/useSharedStore.js'
import useUserStore from '@shared/stores/useUserStore.js'
import useFeatureFlagStore from '@shared/stores/useFeatureFlagStore'

const pinia = createPinia()
pinia.use(createPersistedState())

const app = createApp(App)

Object.keys(directives).forEach((key) => {
  app.directive(key, directives[key])
})

app.use(pinia)
const usStore = useUsStore()

initApi()

const bootstrap = async () => {
  // Apply landing-page tracking params before tracker/router initialization.
  await updateInitialPathAndQueryWithTrackingData()

  app.use(i18n)

  Tracker.initDatadog()
  const router = initRouter()
  Tracker.initSnowplow({
    persistedConfigStore: usePersistedConfigStore(),
    corporateStore: useCorporateStore(),
    sharedStore: useSharedStore(),
    userStore: useUserStore(),
    featureFlagStore: useFeatureFlagStore(),
    router,
  })
  app.use(router)

  usStore.updateSignupContext(generateSignupContext())

  const appSpinner = document.querySelector('#app-spinner')
  if (appSpinner != null) {
    appSpinner.parentNode.removeChild(appSpinner)
  }
  app.mount('#app')
}

bootstrap()

export default app
